
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSlider from './components/HeroSlider';
import Services from './components/Services';
import Staff from './components/Staff';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';

export default function Home() {
  useEffect(() => {
    // Schema.org JSON-LD for LocalBusiness
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "おかやまリフォーム株式会社",
      "description": "岡山市・倉敷市を中心とした岡山県内のリフォーム・修繕工事・店舗工事専門業者",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "○○町1-2-3",
        "addressLocality": "岡山市北区",
        "addressRegion": "岡山県",
        "postalCode": "700-0000",
        "addressCountry": "JP"
      },
      "telephone": "086-012-3456",
      "faxNumber": "086-012-3457",
      "openingHours": "Mo-Sa 09:00-18:00",
      "areaServed": ["岡山市", "倉敷市", "岡山県"],
      "serviceType": ["リフォーム工事", "修繕工事", "店舗工事"],
      "foundingDate": "2000",
      "numberOfEmployees": "5"
    };

    // FAQ Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "リフォーム工事の期間はどのくらいかかりますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "工事内容により異なりますが、キッチンリフォームで3-5日、バスルームリフォームで4-7日、全面リフォームで2-4週間程度が目安です。詳細な工期は現地調査後にお伝えいたします。"
          }
        },
        {
          "@type": "Question",
          "name": "見積もりは無料ですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい、お見積もりは無料です。現地調査からお見積もり作成まで、費用は一切かかりません。お気軽にお問い合わせください。"
          }
        },
        {
          "@type": "Question",
          "name": "岡山市以外でも対応していますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "岡山市・倉敷市を中心に、岡山県内全域で対応しております。エリアによっては出張費をいただく場合がございますので、詳しくはお問い合わせください。"
          }
        },
        {
          "@type": "Question",
          "name": "工事中の生活はどうなりますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "工事箇所により異なりますが、水回りリフォームの場合は仮設設備をご用意いたします。お客様の生活に配慮した工程で進めさせていただきます。"
          }
        },
        {
          "@type": "Question",
          "name": "アフターサービスはありますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "工事完了後も安心してお過ごしいただけるよう、定期点検やメンテナンスサービスを提供しております。不具合があった場合は迅速に対応いたします。"
          }
        },
        {
          "@type": "Question",
          "name": "支払い方法はどのようになりますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "現金、銀行振込、各種クレジットカード、リフォームローンに対応しております。お客様のご都合に合わせた支払い方法をご提案いたします。"
          }
        }
      ]
    };

    // Add schemas to head
    const addSchema = (schema: object, id: string) => {
      const existingScript = document.getElementById(id);
      if (existingScript) {
        existingScript.remove();
      }
      
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    };

    addSchema(localBusinessSchema, 'local-business-schema');
    addSchema(faqSchema, 'faq-schema');

    return () => {
      const localBusinessScript = document.getElementById('local-business-schema');
      const faqScript = document.getElementById('faq-schema');
      if (localBusinessScript) localBusinessScript.remove();
      if (faqScript) faqScript.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSlider />
        <Services />
        <Staff />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
